'use client';

import '@/styles/globals.css';

import { useEffect } from 'react';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  // global-error replaces the root layout, so it must render <html> and <body>.
  return (
    <html lang="en">
      <body>
        <div className="flex h-screen flex-col items-center justify-center px-4">
          <h1 className="mb-6 text-8xl font-medium tracking-tighter tabular-nums">
            500
          </h1>

          <p className="mb-6 text-center font-mono text-sm text-muted-foreground">
            Something went wrong.
          </p>

          <button
            type="button"
            onClick={reset}
            className="inline-flex h-9 items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground shadow-xs hover:bg-primary/90"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
